// Vendor
import { computed, ref } from 'vue';
import { defineStore } from 'pinia';
import { DynamicURL } from '@netvlies/utility-collection';
// Globals
import { API_PREFIX } from '../endpoints';
import { REQUEST_TOKEN } from '../../auth/globals/request';
// Stores
import { useContextStore } from '../../context';
const useSyliusShopOrder = defineStore('order', () => {
    // Composable
    const { $api, $endpoints } = useContextStore();
    // Refs
    const data = ref(null);
    const loaded = ref(false);
    // Computed
    const itemCount = computed(() => { var _a; return ((_a = data.value) === null || _a === void 0 ? void 0 : _a.items.length) || 0; });
    // Methods
    async function fetchByToken(options) {
        const { token, tokenLevel = REQUEST_TOKEN.SECURE, updateState = true } = options;
        if (updateState) {
            data.value = null;
            loaded.value = true;
        }
        const url = new DynamicURL(`${API_PREFIX.SHOP}${$endpoints.ORDER_BY_TOKEN}`)
            .setRouteParams(token)
            .resolve();
        const orderResponse = await $api
            .get(url, {
            tokenLevel,
        })
            .catch((error) => Promise.reject(error));
        const { data: responseData } = orderResponse;
        if (responseData) {
            if (updateState) {
                data.value = responseData;
                loaded.value = true;
            }
            return data;
        }
        return null;
    }
    return {
        data,
        fetchByToken,
        itemCount,
        loaded,
    };
});
export * from '../types/order';
export { useSyliusShopOrder };
//# sourceMappingURL=order.js.map